<template>
  <div
    v-if="loading"
    id="page"
    class="flex flex-col items-center justify-center min-h-screen w-full"
  >
    <div
      class="spinner mx-auto"
      style="border: 3px solid rgb(141 183 227 / 30%);border-top-color: #80b1fc;"
    ></div>
    <div class="p-4" style="color: rgb(78 143 243);">
      Loading, please wait...
    </div>
  </div>
  <div v-else>
    <Navbar
      id="header"
      class="bg-white border-b border-solid border-gray-200 opacity-100 py-2 px-10 shadow"
    >
    </Navbar>

    <header-notification></header-notification>

    <div class="mx-10 mt-5">
      <router-link
        :to="{ name: 'survey-builder', params: { surveyid: survey.id } }"
        class="px-4 font-normal align-middle text-sm border border-transparent cursor-pointer rounded text-gray-400 hover:no-underline hover:text-purple-400"
      >
        <svg-icon
          icon="heroicons/outline/arrow-left"
          class="h-4 w-4 inline-block align-middle"
        ></svg-icon>
        Back to builder
      </router-link>

      <div class="mx-auto mt-10" style="width: 800px">
        <div class="font-bold py-2 text-3xl mx-auto">
          Launch {{ survey.name }}
        </div>

        <div class="rounded-lg shadow-md px-10 pt-5 pb-10 bg-white mb-20">
          <ul class="list-reset flex border-b border-gray-100 mb-5">
            <li class=" mr-2" @click="tab = 1">
              <a
                class=" inline-block py-2 px-4 text-blue font-semibold rounded-t hover:no-underline text-gray-700 hover:text-gray-700"
                :class="{
                  'bg-white border-l border-t border-r py-2 px-4 text-blue-dark':
                    tab == 1,
                  'bg-gray-100 hover:bg-gray-200': tab != 1,
                }"
                href="#"
                >Display Code</a
              >
            </li>
            <li class="mr-2" @click="tab = 2">
              <a
                class=" inline-block py-2 px-4 font-semibold rounded-t hover:no-underline text-gray-700 hover:text-gray-700"
                :class="{
                  'bg-white border-l border-t border-r py-2 px-4 ': tab == 2,
                  'bg-gray-100 hover:bg-gray-200': tab != 2,
                }"
                href="#"
                >Display Settings</a
              >
            </li>
          </ul>

          <div v-if="tab == 1">
            <p class="pb-5 text-gray-700 mt-3">
              Copy the code below and place it before the closing &lt;/body&gt;
              tag on evey page where you'd like your Appflowz to be displayed:
            </p>
            <pre
              class="border border-solid border-gray-700 p-4 rounded text-gray-500"
              style="overflow-x: auto; white-space: pre;width: 100%;min-height:200px;}"
            >
&lt;script type="text/javascript"&gt;
!function(t,e){window.appflowzConfig={};var n=function(){var t=e.createElement("script"),n=e.getElementsByTagName("script")[0];t.src=("https:"==e.location.protocol?"https://":"http://")+"script.appflowz.com/loader.min.js?"+(new Date).getTime(),n.parentNode.insertBefore(t,n)};t.addEventListener?t.addEventListener("load",n,!1):t.attachEvent("onload",n)}(window,document);
&lt;/script&gt;  
&lt;script type="text/javascript"&gt;
window.appflowzConfig = {
    account: "{{ account_id }}", //your Appflowz account id
    email: "jane@doe.com", //user email address
    name: "Jane Q. Doe", //user's name (optional)
    user_id: "abc123xyz", //user's id (optional)
    container: document.currentScript,
};
&lt;/script&gt;
</pre
            >
          </div>

          <div v-if="tab == 2">
            <div class="text-lg mt-5 mb-4">Trigger Settings:</div>

            <div class="mt-1">
              <label class="inline-flex items-center">
                <input
                  type="radio"
                  class="form-radio"
                  v-model="displayTrigger"
                  value="ALWAYS"
                />
                <span class="ml-2">Show always</span>
              </label>
            </div>

            <!--
            <div class="mt-1">
              <label class="inline-flex items-center">
                <input
                  type="radio"
                  class="form-radio"
                  v-model="displayTrigger"
                  value="ONCE"
                />
                <span class="ml-2">Show once</span>
              </label>
            </div>

            -->

            <div class="mt-1">
              <label class="inline-flex items-center">
                <input
                  type="radio"
                  class="form-radio"
                  v-model="displayTrigger"
                  value="UNTIL_RESPOND"
                />
                <span class="ml-2"
                  >Show once per visit until user responds (recommended for
                  surveys)</span
                >
              </label>
            </div>

            <div class="text-lg mt-5 mb-4">Page Settings:</div>

            <div class="flex flex-row items-start">
              <div class="flex flex-row flex-none justify-start items-center">
                <div class="flex-none">Display on</div>

                <select
                  v-model="displayDomain"
                  class="mx-2 py-2 pr-3 border border-blue-300 bg-white rounded-md shadow-sm focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm"
                >
                  <option value="ALL">on all domains</option>
                  <option value="CONTAINS"> on all domains that contain</option>
                </select>
              </div>

              <div class="flex-grow" v-if="displayDomain != 'ALL'">
                <textarea
                  v-model="displayDomainList"
                  placeholder="example.com"
                  class="mx-2 p-2 w-full border border-blue-300 bg-white rounded-md shadow-sm focus:outline-none focus:ring-indigo-500"
                />
                <div class="text-sm text-gray-300 ml-2">
                  List one domain or subdomain per line. "example.com" will
                  match www.example.com, app.example.com, etc.
                </div>
              </div>
            </div>

            <div class="flex flex-row items-start mt-3">
              <div class="flex flex-row flex-none justify-start items-center">
                <div class="flex-none">Display on</div>

                <select
                  v-model="displayPage"
                  class="mx-2 py-2 pr-3 border border-blue-300 bg-white rounded-md shadow-sm focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm"
                >
                  <option value="ALL">on all pages</option>
                  <option value="STARTS_WITH">
                    on all pages that start with</option
                  >
                  <option value="CONTAINS"> on all pages that contain</option>
                </select>
              </div>

              <div class="flex-grow" v-if="displayPage != 'ALL'">
                <textarea
                  v-model="displayPageList"
                  placeholder="/apps/index/                                                                           /users/show/"
                  class="mx-2 p-2 w-full border border-blue-300 bg-white rounded-md shadow-sm focus:outline-none focus:ring-indigo-500"
                />
                <div class="text-sm text-gray-300 ml-2">
                  Matches the path after the domain, e.g.:
                  http//www.example.com/[path] (one per line)
                </div>
              </div>
            </div>

            <button
              @click="saveSurvey()"
              class=" mt-10 hover:text-white hover:no-underline block bg-purple-600 hover:bg-purple-500 text-white active:bg-purple-600 font-bold uppercase text-xs px-4 py-3 rounded-md shadow hover:shadow-md outline-none focus:outline-none mb-1"
              type="button"
              style="transition: all .15s ease"
            >
              Save Settings
            </button>

           

            <div class="mx-auto w-max">

               <div class="text-lg mt-5 mb-4 font-bold">Activate this campaign:</div>

            <div class="flex flex-row">
              <BaseToggle
                v-model="published"
                name="published"
                class="h-6 my-auto mr-5"
              />
              <div class="my-auto ml-2">
                Campaign is <u>{{ published ? "Active" : "Paused" }}</u>
              </div>
            </div>
            </div>

            <hr class="mt-5" />

            <p class="my-5 text-gray-700">
              For post-signup survey flows, we recommend selecting "Display
              until user responds" and showing it on all pages. Alternatively,
              you can set it to display on the first page that is shown to the
              user after completing their registration, such as the main
              Dashboard page.
            </p>
            <p class="pb-5 text-gray-700">
              Your survey flow will be shown in a full screen overlay over the
              page and will automatically close after the user completes the
              survey.
            </p>

            <p class="font-bold pb-5 pt-5">Before</p>

            <img
              src="https://s3.amazonaws.com/images.appflowz.com/Install+Before.png"
            />

            <p class="font-bold pt-5 pb-5">
              After (survey displayed over "Dashboard" page)
            </p>

            <img
              src="https://s3.amazonaws.com/images.appflowz.com/Pixel+Install+Wireframe.png"
            />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Survey from "@/models/Survey";
import Navbar from "@/components/Header.vue";
import HeaderNotification from "@/components/HeaderNotification.vue";
export default {
  props: ["surveyid"],
  data() {
    return {
      loading: false,
      tab: 1,
    };
  },
  components: { Navbar, HeaderNotification },
  computed: {
    survey() {
      return Survey.query()
        .whereId(this.surveyid)
        .first();
    },
    account_id() {
      return this.$store.state.auth.user.account;
    },
    published: {
      get() {
        return this.survey.published;
      },
      async set(value) {
        if (value !== this.survey.published) {
          await Survey.update({
            where: this.survey.id,
            data: {
              published: value,
            },
          });

          this.saving = true;
          let post = await Survey.api().post("/api/survey/save", this.survey);

          if (post.response.status == 200) {
            this.$store.dispatch("notification/add", {
              message:
                value == 1
                  ? "Campaign is launched!"
                  : "Campaign has been paused.",
            });
          } else {
            this.$store.dispatch("notification/add", {
              message: post.response.data.error.message,
            });
          }

          /*
          try {
            await Survey.api().post("/api/survey/save", this.survey);
          } catch (err) {
            //Log error
            this.$store.dispatch("notification/add", {
              message: "An error occured saving survey",
            });
          }
          */

          this.saving = false;
        }
      },
    },
    displayTrigger: {
      get() {
        return this.survey.displayTrigger;
      },
      set(value) {
        if (value !== this.survey.displayTrigger) {
          Survey.update({
            where: this.survey.id,
            data: { displayTrigger: value },
          });
          //this.saveSurvey();
        }
      },
    },
    displayDomain: {
      get() {
        return this.survey.displayDomain;
      },
      set(value) {
        if (value !== this.survey.displayDomain) {
          Survey.update({
            where: this.survey.id,
            data: { displayDomain: value },
          });
          //this.saveSurvey();
        }
      },
    },
    displayDomainList: {
      get() {
        return this.survey.displayDomainList;
      },
      set(value) {
        if (value !== this.survey.displayDomainList) {
          Survey.update({
            where: this.survey.id,
            data: { displayDomainList: value },
          });
          //this.saveSurvey();
        }
      },
    },
    displayPage: {
      get() {
        return this.survey.displayPage;
      },
      set(value) {
        if (value !== this.survey.displayPage) {
          Survey.update({
            where: this.survey.id,
            data: { displayPage: value },
          });
          //this.saveSurvey();
        }
      },
    },
    displayPageList: {
      get() {
        return this.survey.displayPageList;
      },
      set(value) {
        if (value !== this.survey.displayPageList) {
          Survey.update({
            where: this.survey.id,
            data: { displayPageList: value },
          });
          //this.saveSurvey();
        }
      },
    },
    hideRepeat: {
      get() {
        return this.survey.hideRepeat;
      },
      set(value) {
        if (value !== this.survey.hideRepeat) {
          Survey.update({ where: this.survey.id, data: { hideRepeat: value } });
          this.saveSurvey();
        }
      },
    },
  },
  methods: {
    async saveSurvey() {
      let post = await Survey.api().post("/api/survey/save", this.survey);

      if (post.response.status == 200) {
        this.$store.dispatch("notification/add", {
          message: "Display settings saved.", //post.response.data.success.message,
        });
      } else {
        this.$store.dispatch("notification/add", {
          message: post.response.data.error.message,
        });
      }
    },
  },
  async created() {
    this.loading = true;

    //if survey is not already loaded in state, request it from the server
    if (this.survey === null) {
      await Survey.api().get("/api/survey/" + this.surveyid, {
        dataKey: "data",
      });
    }
    this.loading = false;
  },
};
</script>

<style></style>
